import axios from "axios";
import { host } from "./utilities";

axios.defaults.withCredentials = true;
export const corporateActionsServiceHealthCheckAxios = () => (config) => axios.get(`${host()}/health-check`, config);
